import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTypeService as ComponentService } from '../document-type.service';
import { DocumentCategoryService } from '../../document-category/document-category.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import {
  DocumentType as objectPayload,
  DocumentTypeAddPayload as objectAddPayload,
  DocumentTypeEditPayload as objectEditPayload,
  DocumentTypeForm as objectForm,
} from '../document-type.interface';

@Component({
  selector: 'app-edit-document-type',
  templateUrl: './edit-document-type.component.html',
  styleUrls: ['./edit-document-type.component.scss'],
})
export class EditDocumentTypeComponent implements OnInit {
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name, [Validators.required]),
    slug: new FormControl(this.data.slug, [Validators.required]),
    categorie_id: new FormControl(this.data.categorie_id, [
      Validators.required,
    ]),
  });

  categories$: any = [];

  defaultParameter: { name: string; id: string } = {
    name: '--Alegeți--',
    id: '-1',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditDocumentTypeComponent>,
    private componentService: ComponentService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private documentCategoryService: DocumentCategoryService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.loadDocumentCategories();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.componentService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, slug, categorie_id } = this.form.value as objectPayload;
    const updateObj: objectEditPayload = {
      id: this.data.id,
      categorie_id,
      name,
      slug,
    };

    this.componentService
      .update(updateObj)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            helper.dialogConfig.headers.errorAtentie,
            msg,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let msg;
      try {
        // try to catch the message from server
        msg = res.error.errors.message[0];
      } catch (error) {
        // controll output message
        msg = helper.dialogConfig.generalMessages.error;
      }
      this.notificationService.warningSwal(
        this.errorTitle,
        msg,
        this.errorIcon
      );
    }
  }

  loadDocumentCategories() {
    this.isLoading = true;
    this.categories$ = this.documentCategoryService.getRecordsList().pipe(
      map((results: any) => [this.defaultParameter, ...results]),
      finalize(() => (this.isLoading = false))
    );
  }
}
